import React, {useState, useEffect} from 'react'

const ButtonMarker = (props) => {
    const style = {
        position: "absolute",
        top: (props.value.cam_pos_y ? props.value.cam_pos_y : props.value.pos_y)+"%",
        left: (props.value.cam_pos_x ? props.value.cam_pos_x : props.value.pos_x)+"%",
        backgroundColor: props.value.button_bg,
        color: props.value.button_color_text,
        transform: `scale(${props.value.button_scale})`,
        fontSize: `${props.value.button_font_size * props.viewHeight / 100}px`,
        width: `${props.value.button_width*props.viewHeight/100}px`,
        height: `${props.value.button_height*props.viewHeight/100}px`,
        borderRadius: props.value.button_radius+"vh",
        fontWeight: props.value.button_font_weight,
        fontStyle: props.value.button_font_style,
        fontFamily: props.value.button_font_family,
    }

    return (
        <button className={props.value.button_class} id={props.value.id}
        style={style}>
            {props.value.button_label}
        </button>
    )
}

export default ButtonMarker;